export default function textWrapper(text, containerWidth, char_size, isHTML = false ) {

    let splittedText = [];


    let CHARACTER_BY_ROW = containerWidth / char_size
    let textArr = text.split(' ');

    let y = 0

    for (let i = 0; i < textArr.length; i++) {
        const word = textArr[i];
        if (!splittedText[y]) {
            splittedText[y] = word
        } else if (splittedText[y].length + word.length < CHARACTER_BY_ROW) {
            splittedText[y] += ' ' + word
        } else {
            y++
            splittedText[y] = word
        }
    }


    let html = ''
    for (let j = 0; j < splittedText.length; j++) {
        if (j == splittedText.length - 1) {
            html +=  splittedText[j]
        } else {
            if(!isHTML) {
                html += splittedText[j] + `
                `
            }
            else {
                html += splittedText[j] + '<br/>'
            }
        }
    }

    return html;
}